<template>
	<div class="component social-share">
		<div class="button-container">
			<button
				class="uk-button uk-button-medium nn-share-button"
				:class="platform"
					v-for="platform in platforms"
					:key="platform"
					type="button"
					:aria-label="getPlatformLabel(platform)"
					:title="getPlatformLabel(platform)"
					@click="share(platform)"
			>
				<span :uk-icon="'icon: ' + getIconName(platform)"></span>
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SocialShare',
	props: {
		url: {
			type: String,
			default: () => window.location.href,
		},
		title: {
			type: String,
			default: '',
		},
		platforms: {
			type: Array,
			default: () => [],
		},
	},
	methods: {
		share(platform) {
			
			const component = this;
			const encodedUrl = encodeURIComponent(this.url);
			const encodedTitle = encodeURIComponent(this.title);
			let shareUrl = '';

			switch (platform) {
				case 'facebook':
					shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
					break;
				case 'x':
					shareUrl = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`;
					break;
				case 'linkedin':
					shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=${encodedTitle}`;
					break;
				case 'whatsapp':
					shareUrl = `https://api.whatsapp.com/send?text=${encodedTitle} ${encodedUrl}`;
					break;
				case 'link': 
					component.copyToClipboard();
					return;
				case 'email':
					shareUrl = `mailto:?subject=${encodedTitle}&body=${encodedUrl}`;
					window.location.href = shareUrl;
					return;
				default:
					console.error('Unsupported platform');
					return;
			}

			window.open(shareUrl, '_blank', 'noopener,noreferrer');
		},
		getIconName(platform) {
			// Map platform to icon name here
			const platformIcons = {
				facebook: 'facebook',
				x: 'x', 
				linkedin: 'linkedin',
				whatsapp: 'whatsapp',
				email: 'mail',
				link: 'link'
			};
			return platformIcons[platform] || 'question'; // Default icon if not found
		},
		getPlatformLabel(platform) {
			const labels = {
				facebook: 'Delen op Facebook',
				x: 'Delen op X',
				linkedin: 'Delen op LinkedIn',
				whatsapp: 'Delen via WhatsApp',
				email: 'Delen via e-mail',
				link: 'Link kopiëren',
			};

			return labels[platform] || 'Artikel delen';
		},
		async copyToClipboard() {
			try {
				await navigator.clipboard.writeText(this.url);
				UIkit.modal.alert('URL naar clipboard gekopieerd')
			} catch (err) {
				console.error('Failed to copy: ', err);
			}
		},
	},
};
</script>

<style scoped>
.component.social-share {
}
.component.social-share .button-container {
		display: flex;
		flex-wrap: wrap;
		gap: 8px; 
		overflow-x: auto;
}
.component.social-share .button-container .nn-share-button {
	display: grid;
	flex: 0 0 42px;
	width: 42px;
	height: 42px;
	min-height: 42px;
	padding: 0;
	place-items: center;
	border: 1px solid var(--nn-border);
	border-radius: 999px;
	background: var(--nn-surface);
	color: var(--nn-text) !important;
	line-height: 1;
	transition: transform 150ms ease, border-color 150ms ease, background-color 150ms ease, color 150ms ease, box-shadow 150ms ease;
}
.component.social-share .button-container .nn-share-button:hover,
.component.social-share .button-container .nn-share-button:focus-visible {
	transform: translateY(-1px);
	border-color: var(--nn-accent);
	background: var(--nn-accent-soft);
	color: var(--nn-accent) !important;
	box-shadow: 0 7px 18px color-mix(in srgb, var(--nn-accent) 12%, transparent);
}
.component.social-share .button-container .nn-share-button:active {
	transform: translateY(0);
	box-shadow: none;
}
.component.social-share .button-container .nn-share-button span,
.component.social-share .button-container .nn-share-button svg {
	display: block;
	color: inherit;
}

@media (min-width: 768px) { /* Adjust breakpoint as needed for desktop */
		.component.social-share .button-container .responsive-button {
				flex: 0 1 auto; /* Do not grow, but allow shrink */
		}
}


</style>
